import React from "react";
import TourPackageCard from "./TourPackageCard";

function HomeTourPackagesSection({ title = "Popular tour packages", packages, onOpenPackage }) {
  if (!packages || packages.length === 0) return null;

  return (
    <section className="space-y-4">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
            Top picks for you
          </p>
          <h2 className="text-lg md:text-xl font-semibold tracking-tight">
            {title}
          </h2>
        </div>
      </div>

      <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {packages.map((pkg) => {
          const packageId = pkg?.Package?.PackageID || pkg?.PackageID;
          return (
            <TourPackageCard
              key={packageId}
              pkg={pkg}
              onOpen={() =>
                onOpenPackage && onOpenPackage(packageId, pkg)
              }
            />
          )
        })}
      </div>
    </section>
  );
}

export default HomeTourPackagesSection;
